// ignore-string-externalization

import React from 'react';
import { createWidget } from '@typeform/embed';
import { spacer8 } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { TemplateType } from '.';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { Wait } from '../Layout';

export type TypeformTemplateType = TemplateType & {
  formId?: string;
  requiredFeatureFlag?: string;
  forceLogin?: boolean;
};

const TypeformContainer = styled.div`
  width: 100%;
  height: 100vh;

  .typeform-widget {
    width: 100%;
    height: 100%;
    iframe {
      width: 100%;
      height: 100%;
      border: none;
      overflow: hidden;
      border-radius: ${spacer8};
    }
  }
`;

export const TypeformTemplate: React.FC<TypeformTemplateType> = ({
  formId,
  forceLogin = true,
}) => {
  const user = useCurrentUser();
  const formRef = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if ((!forceLogin || user) && formId) {
      createWidget(formId, {
        container: formRef.current!,
        hideHeaders: true,
        hideFooter: true,
        hidden: {
          partner_id: user?.partnerIds?.google || 'unknown',
        },
      });
    }
  }, [user, formId, formRef]);

  return (
    <TypeformContainer ref={formRef}>
      {forceLogin && !user && <Wait cover />}
    </TypeformContainer>
  );
};
